import type { Patient } from '@medplum/fhirtypes'
import { LAB_VENDOR_PARENT_NAME } from '@/model/middleware-types'
import { FacilityDiscovery } from './discovery/FacilityDiscovery'
import type { LabVendor } from './discovery/discoveryTypes'
import type { Facility } from './shared/facilityTypes'
import { OrderDeliveryStep } from './shared/OrderDeliveryStep'

type Props = {
  patient: Patient
  vendor: LabVendor
  selectedFacilityId: string
  onSelectFacility: (organizationId: string, facility: Facility | null) => void
  /** PD-1312 — the patient carries a printable requisition to any of the chain's locations. */
  patientChoosesLocation: boolean
  onPatientChoosesLocation: () => void
  /** PD-1929 — fax delivery chosen; the form drops the patient-chosen location. */
  onFaxDelivery: () => void
  /** Fax delivery was chosen, even before a facility is picked (kept by the form). */
  faxDeliveryChosen: boolean
  canAdvance: boolean
  onBack: () => void
  onNext: () => void
  /** The fax the order currently goes to, so the facility search shows it on return. */
  selectedFacilityFax?: string
}

/** PD-1929 — the lab orders' "Order delivery" step (Quest, Labcorp). */
export const LabFacilityStep = ({
  patient,
  vendor,
  onSelectFacility,
  selectedFacilityFax,
  ...step
}: Props) => (
  <OrderDeliveryStep
    {...step}
    placeName={LAB_VENDOR_PARENT_NAME[vendor]}
    renderDiscovery={(choosePatient) => (
      <FacilityDiscovery
        patient={patient}
        kind="lab"
        vendor={vendor}
        selectedFacilityId={step.selectedFacilityId}
        onSelectFacility={onSelectFacility}
        onPatientChoosesLocation={choosePatient}
        selectedFacilityFax={selectedFacilityFax}
      />
    )}
  />
)
